module.exports = __webpack_public_path__ + "static/resources-list-3-75190e3c892ea031b55a25f2d168bfb5.png";